// extracted by mini-css-extract-plugin
export default {"content":"b8Gjtlyb9Mc5wNGF0ld9"};